<template>
  <v-dialog
    v-model="dialog"
    width="759px"
  >
    <v-card>
      <v-card-title class="text-h6 grey lighten-2">{{ $t('warning') }}</v-card-title>
      <v-card-text class="mt-4 black--text font-weight-bold">{{ $t('qrcode_modal_content') }}</v-card-text>
      <v-card-text class="black--text">{{ isAvailable('qrmanager:elabel') ? $t('qrcode_modal_sub_content_elabel') : $t('qrcode_modal_sub_content_non_elabel') }}</v-card-text>

      <v-card-actions class="pa-4 px-8 mt-5 pb-6">
        <v-spacer></v-spacer>
        <v-btn
          text
          class="blue--text mr-6"
          @click="closeModal"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          class="primary white--text"
          @click="handleConfirmBtnClick"
        >
          {{ $t('qrcode_s1_modal_understand_change') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'edit-confirmation-modal',
  data: () => ({}),
  props: {
    displayEditModal: {
      type: Boolean,
      required: true
    },
    selectedCode: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters(['isAvailable']),
    dialog: {
      get () {
        return this.displayEditModal
      },
      set (value) {
        this.$emit('update:displayEditModal', value)
      }
    }
  },
  methods: {
    ...mapMutations({
      setSelectedProductCode: 'SET_SELECTED_PRODUCT_CODE',
      setCodeEditing: 'SET_CODE_EDITING'
    }),

    closeModal () {
      this.dialog = !this.dialog
    },
    handleConfirmBtnClick () {
      this.updateProductState()
      this.dialog = !this.dialog
      this.$emit('open-dialog')
    },
    updateProductState () {
      // update selected product code only after confirm button is clicked
      this.setCodeEditing(true)
      this.setSelectedProductCode(this.selectedCode)
    }
  }

}
</script>
